var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRrcLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.27273,
    height: 3.27273,
    rx: 1.63636,
    fill: "#656565"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 4.9082,
    width: 3.27273,
    height: 8.18182,
    rx: 1.63636,
    fill: "#656565"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.90942,
    y: 4.9082,
    width: 3.27273,
    height: 8.18182,
    rx: 1.63636,
    fill: "#656565"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 14.7266,
    width: 3.27273,
    height: 3.27273,
    rx: 1.63636,
    fill: "#656565"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.90942,
    width: 3.27273,
    height: 3.27273,
    rx: 1.63636,
    fill: "#656565"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.81812,
    width: 3.27273,
    height: 3.27273,
    rx: 1.63636,
    fill: "#656565"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9.81812,
    y: 4.9082,
    width: 3.27273,
    height: 3.27273,
    rx: 1.63636,
    fill: "#656565"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7275,
    width: 3.27273,
    height: 8.18182,
    rx: 1.63636,
    fill: "#656565"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7275,
    y: 9.81836,
    width: 3.27273,
    height: 3.27273,
    rx: 1.63636,
    fill: "#656565"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7275,
    y: 14.7266,
    width: 3.27273,
    height: 3.27273,
    rx: 1.63636,
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRrcLogoIcon);
export default __webpack_public_path__ + "static/media/rrc_Logo_icon.a1c5687f528c0cd5ddb51c9a3c700f4a.svg";
export { ForwardRef as ReactComponent };